import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'yoda-core-components/lib/components/Button';
import SlidePanel from 'yoda-site-components/lib/components/SlidePanel/SlidePanel';
import NativeSliderTitle from 'yoda-site-components/lib/components/NativeSliderTitle/NativeSliderTitle';
import { ORDER_DETAILS } from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ConfirmationDetails from '../ConfirmationDetails/ConfirmationDetails';
import * as styles from '../ConfirmationMessage/ConfirmationMsg.css';

class OrderDetailsLink extends Component {
    static propTypes = {
        isNative: PropTypes.bool,
        OCPPagePass: PropTypes.string,
        cancelOrderLink: PropTypes.string,
    };

    static defaultProps = {
        isNative: false,
        OCPPagePass: '',
        cancelOrderLink: '',
    };

    constructor(props) {
        super(props);
        this.state = {
            isPanelOpen: false,
        };
        this.showOrderDetails = this.showOrderDetails.bind(this);
        this.pageRedirectODP = this.pageRedirectODP.bind(this);
    }

    onClosePanel = () => {
        this.setState({
            isPanelOpen: false,
        });
        // Release the body scroll lock while slide panel close
        document.body.style.position = 'inherit';
    };

    /* istanbul ignore next */
    pageRedirectODP = () => {
        const { cancelOrderLink } = this.props;
        window.location.href = cancelOrderLink;
    };

    showOrderDetails(event) {
        event.preventDefault();
        this.setState({
            isPanelOpen: true,
        });
        // Lock the body scroll while slide panel open
        document.body.style.position = 'fixed';
    }

    render() {
        const { isNative, OCPPagePass } = this.props;
        return (
            <div>
                <p>&nbsp;</p>
                <Button
                    automationId="orderDetailsLink"
                    buttonType="Link"
                    size="Md"
                    className={`${styles.viewOrderDetails} ${dt(['!p-0'])}`}
                    onClick={
                        OCPPagePass && OCPPagePass !== ''
                            ? this.showOrderDetails
                            : this.pageRedirectODP
                    }
                >
                    View Order Details
                </Button>
                <div>
                    <SlidePanel
                        panelTitle={ORDER_DETAILS}
                        panelTitleClass={dt(['pl-[120px]'])}
                        isOpenPanel={this.state.isPanelOpen}
                        onClosePanel={this.onClosePanel}
                    >
                        {isNative && (
                            <NativeSliderTitle
                                title={ORDER_DETAILS}
                                classes={dt(['ml-6', 'mb-2', 'mt-2'])}
                            />
                        )}
                        <ConfirmationDetails />
                    </SlidePanel>
                </div>
            </div>
        );
    }
}

export default OrderDetailsLink;
